






































import { Component, Prop, Vue } from 'vue-property-decorator'

import AlertSection from './AlertSection.vue'
import ButtonWithMessage from './ButtonWithMessage.vue'
import { ViewModel } from './model/view-model'
import StatusIcon from './StatusIcon.vue'

@Component({
  components: {
    AlertSection,
    ButtonWithMessage,
    StatusIcon,
  },
})
export default class ExternalPaymentCallbackView extends Vue {
  @Prop({ required: true })
  model: ViewModel
}
